import { Directive } from '@angular/core';

@Directive({
  selector: '[app-nav-page-subtitle]',
  host: {
    class: 'prose prose-text-sm text-neutral-500'
  }
})
export class NavPageSubtitle {}
